/** Compte plateforme (gestion globale : création d’entreprises, liaison HubUP). */
export function isPlatformAdmin(user) {
  return user?.permission === 'admin';
}
